import * as React from 'react'
import { useNavigate } from '@reach/router';
import { Wrapper, Form, ButtonWrapper } from './StepTwoStyle.js'
import Input from 'components/Input/Input';
import Button from 'components/Button/Button.jsx';
import Select from 'components/Select/Select.jsx';
import { useInvoice } from "store/context";
import {
   resolvedStamp,
   resetLoadedStamp
} from 'store/actions'

import { toast, ToastContainer } from "react-toastify";
import { validateEmails } from "helpers/validate";
//hooks
import { useForm } from 'hooks/useForm'

//forma de pago SAT '99' (POR DEFINIR) no es valida para timbrar una factura
const UNDEFINED_PAYMENT_CODE = '99'

function StepTwo() {
   const navigate = useNavigate()
   const { state: { customer, loadStamp, origin }, dispatch } = useInvoice();

   const regimes = customer?.regimes;
   const uses = customer?.uses;
   const paymentTypes = customer?.paymentTypes?.filter(
      (paymentType) => paymentType?.code !== UNDEFINED_PAYMENT_CODE
   );

   const blank_regime = [{ code: '', description: 'Seleccionar un regimen' }]
   const blank_use = [{ code: '', description: 'Seleccionar un uso' }]
   const blank_payment = [{ code: '', description: 'Seleccionar una forma de pago' }]

   const valuesRegimes = blank_regime.concat(regimes || [])
   const valuesUses = blank_use.concat(uses || [])
   const valuesPayment = blank_payment.concat(paymentTypes || [])

   const formState = {
      rfc: customer?.fiscalCustomer?.rfc,
      name: customer?.fiscalCustomer?.name,
      address: customer?.fiscalCustomer?.address,
      email: customer?.fiscalCustomer?.email,
      use: customer?.fiscalCustomer?.purpose,
      regime: customer?.fiscalCustomer?.regime,
      payment: customer?.note?.paymentTypeCode === UNDEFINED_PAYMENT_CODE
         ? ''
         : customer?.note?.paymentTypeCode
   }

   const { inputValues, handleInputOnChange } = useForm(formState);

   //values form
   const {
      rfc,
      name,
      address,
      email,
      use,
      regime,
      payment
   } = inputValues

   //captcha state
   const [validSubmit, setValidSubmit] = React.useState(false)

   //required fields
   const [requiredField, setRequiredField] = React.useState({
      rfc: '',
      name: '',
      address: '',
      email: '',
      regime: '',
      use: '',
      payment: '',
   });

   const onChange = (value) => {
      if (value) setValidSubmit(!validSubmit)
   }

   const handleExpired = () => {
      setValidSubmit(!validSubmit)
   }

   const handleStamp = async (event) => {
      event.preventDefault()
      let body = {};
      // const recaptchaValue = recaptchaRef.current.getValue()
      //validate emails
      const res = validateEmails(email);
      if (!rfc) {
         setRequiredField((prevState) => ({ ...prevState, rfc: 'error' }))
      }
      if (!name) {
         setRequiredField((prevState) => ({ ...prevState, name: 'error' }))
      }
      if (!address) {
         setRequiredField((prevState) => ({ ...prevState, address: 'error' }))
      }
      if (!regime) {
         setRequiredField((prevState) => ({ ...prevState, regime: 'error' }))
      }
      if (!use) {
         setRequiredField((prevState) => ({ ...prevState, use: 'error' }))
      }
      if (!payment) {
         setRequiredField((prevState) => ({ ...prevState, payment: 'error' }))
      }
      if (!email) {
         setRequiredField((prevState) => ({ ...prevState, email: 'error' }))
      }

      if (!res) {
         toast.error('El email no es valido', { theme: 'colored' })
         return
      }
      // if(!recaptchaValue) {
      //    toast.error('Captcha invalido', { theme: 'colored'})
      //    return
      // }

      if (name && address && regime && use && payment && email) {
         body = {
            idNote: customer.note.id,
            paymentCode: payment,
            fiscalCustomer: {
               rfc: rfc,
               name: name,
               postal_code: address,
               email: email,
               sat_tax_regime_code: regime,
               sat_cfdi_use_code: use,
               paymentCode: payment
            },
            invoiceKey: origin.webID,
            folio: origin.folio,
            date: origin.date
         }
         setRequiredField('')
         await dispatch(resolvedStamp(dispatch, body))
      }
   }

   React.useEffect(() => {
      resetLoadedStamp(dispatch)
   }, [])

   React.useEffect(
      () => {
         if (loadStamp === 'resolved') {
            navigate('/archivos')
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [loadStamp]
   )
   //re-render captcha beetwen pages
   // React.useEffect(
   //    () => {
   //    const timeoutID  = setTimeout(() =>{
   //       window.grecaptcha.render('captcha-element', {
   //          sitekey: process.env.REACT_APP_CAPTCHA_API_KEY,
   //       });
   //    }, 300)
   //    return () => clearTimeout(timeoutID)
   //    }, []
   // )
   return (
      <>
         <Wrapper>
            <Form>
               <Input
                  requiredField={requiredField.rfc}
                  placeholder="RFC"
                  type="text"
                  value={rfc}
                  onChange={handleInputOnChange}
                  name="rfc"
               />

               <Input
                  requiredField={requiredField.name}
                  placeholder="Nombre"
                  type="text"
                  value={name}
                  onChange={handleInputOnChange}
                  name="name"
               />

               <Input
                  requiredField={requiredField.address}
                  placeholder="Codigo Postal"
                  type="text"
                  value={address}
                  onChange={handleInputOnChange}
                  name="address"
               />

               <Input
                  requiredField={requiredField.email}
                  placeholder="Email"
                  type="email"
                  value={email}
                  name="email"
                  onChange={handleInputOnChange}
               />

               <Select
                  onChange={handleInputOnChange}
                  name="regime"
                  value={regime}
                  requiredField={requiredField.regime}
               >
                  {valuesRegimes?.map((use) => (
                     <option key={use?.code} value={use?.code} >
                        {use?.description}
                     </option>
                  ))}
               </Select>

               <Select
                  onChange={handleInputOnChange}
                  name="use"
                  value={use}
                  requiredField={requiredField.use}
               >
                  {valuesUses?.map((use) => (
                     <option key={use?.code} value={use?.code} >
                        {use?.description}
                     </option>
                  ))}
               </Select>

               <Select
                  onChange={handleInputOnChange}
                  name="payment"
                  value={payment}
                  requiredField={requiredField.payment}
               >
                  {valuesPayment?.map((payment) => (
                     <option key={payment?.code} value={payment?.code} >
                        {payment?.description}
                     </option>
                  ))}
               </Select>

            </Form>
            {/* <CaptchaWrapper>
                  <ReCAPTCHA
                     ref={recaptchaRef}
                     id="captcha-element"
                     sitekey={process.env.REACT_APP_CAPTCHA_API_KEY}
                     onChange={onChange}
                     onExpired={handleExpired}
                  ></ReCAPTCHA>
               </CaptchaWrapper> */}
            <ButtonWrapper>
               <Button handleClick={handleStamp} disabled={loadStamp === 'pending' ? true : false}> {
                  loadStamp === "pending"
                     ? "Enviando..."
                     : "Enviar"
               } </Button>
            </ButtonWrapper>
         </Wrapper>
         <ToastContainer autoClose={4000} />
      </>
   )
}

export default StepTwo;